// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"3bf627fb","830":"b376d7bb"}[chunkId] + ".chunk.js";
};